import React, { useEffect, useMemo, useState } from 'react'
import { Modal, Select, Table } from 'antd'

const columns = [
  {
    title: '',
    dataIndex: 'label',
    key: 'label',
  },
  {
    title: 'Attuale',
    dataIndex: 'current',
    key: 'current',
  },
  {
    title: 'Futura',
    dataIndex: 'future',
    key: 'future',
  }
];

export default function ModalStockComparison(props) {
  const { visible, onClose, dossier, gridApi } = props;
  const [dossierProducts, setDossierProducts] = useState([]);

  useEffect(() => {
    if (!gridApi || !visible) return;
    const allRows = [];
    gridApi.forEachNode((node) => {
      allRows.push(node.data);
    });
    setDossierProducts(allRows);
  }, [gridApi, visible])

  const data = useMemo(() => {
    const dataObj = {
      numeroReferenze: {
        current: 0,
        future: 0,
        order: 1,
        label: 'Numero Referenze',
      },
      stockValue: {
        current: 0,
        future: 0,
        order: 2,
        label: 'Valore Stock',
      },
      stockGlobal: {
        current: 0,
        future: 0,
        order: 3,
        label: 'Stock a Pz',
      },
      ca: {
        current: 0,
        future: 0,
        order: 4,
        label: 'CA',
      },
      stockCoverageDays: {
        current: 0,
        future: 0,
        order: 5,
        label: 'Giorni Copertura',
        precision: 0,
      }
    };

    dossierProducts.forEach((product) => {
      if (
        (dossier.idStore === null && product.precotopReappro === 2) ||
        (dossier.idStore !== null && product.topReapproBi === 2)
      ) {
        dataObj.numeroReferenze.current += 1;
        dataObj.stockValue.current += product.stockValue ?? 0;
        dataObj.stockGlobal.current += product.stockGlobal ?? 0;
        dataObj.ca.current += product.caLast12Months ?? 0;
      }

      if (
        (dossier.idStore === null && product.precotopReapproToBe === 2) ||
        (dossier.idStore !== null && product.topReappro === 2)
      ) {
        dataObj.numeroReferenze.future += 1;
        dataObj.stockValue.future += product.stockValue ?? 0;
        dataObj.stockGlobal.future += product.stockGlobal ?? 0;
        dataObj.ca.future += product.caLast12Months ?? 0;
      }
    });

    if (dataObj.ca.current / 360 !== 0) {
      dataObj.stockCoverageDays.current = Math.round(dataObj.stockValue.current / (dataObj.ca.current / 360));
    }

    if (dataObj.ca.future / 360 !== 0) {
      dataObj.stockCoverageDays.future = (dataObj.stockValue.future / (dataObj.ca.future / 360));
    }

    return Object.keys(dataObj)
      .sort((a, b) => dataObj[a].order - dataObj[b].order)
      .map((key) => ({
        key,
        current: dataObj[key].current?.toFixed(dataObj[key].precision ?? 2) ?? 0,
        future: dataObj[key].future?.toFixed(dataObj[key].precision ?? 2) ?? 0,
        label: dataObj[key].label,
      }));
  }, [dossierProducts]);

  return (
    <Modal
      title={dossier.idStore === null ? 'Sintesi stock (Precotop Reappro 2)' : 'Sintesi stock (Top Reappro 2)'}
      visible={visible}
      footer={null}
      onCancel={onClose}
    >
      <Table
        columns={columns}
        dataSource={data}
        size="small"
        bordered
        pagination={false}
      />
    </Modal>
  )
}
